"use client";

import { useOtpAuth } from "./use-otp-auth";
import { EmailStep } from "./email-step";
import { OtpStep } from "./otp-step";

interface OtpAuthProps {
  className?: string;
  redirectTo?: string;
  emailCtaLabel?: string;
  instantAccount?: boolean;
  enableReferralCode?: boolean;
  initialReferralCode?: string;
}

export function OtpAuth({
  className,
  redirectTo,
  emailCtaLabel,
  instantAccount,
  enableReferralCode,
  initialReferralCode,
}: OtpAuthProps) {
  const {
    step,
    email,
    referralCode,
    setReferralCode,
    referralCodeError,
    enableReferralCode: referralCodeEnabled,
    countdown,
    isSubmitting,
    error,
    emailForm,
    otpForm,
    handleSocialSignIn,
    handleEmailSubmit,
    handleOtpSubmit,
    handleResendOtp,
    handleBack,
  } = useOtpAuth({
    redirectTo,
    instantAccount,
    enableReferralCode,
    initialReferralCode,
  });

  return (
    <div className={className}>
      {error && (
        <div className="bg-destructive/10 text-destructive mb-4 rounded-md p-3 text-sm">
          {error}
        </div>
      )}

      {step === "email" && (
        <EmailStep
          form={emailForm}
          isSubmitting={isSubmitting}
          onSubmit={handleEmailSubmit}
          onSocialSignIn={handleSocialSignIn}
          ctaLabel={emailCtaLabel}
          showReferralCode={referralCodeEnabled}
          referralCode={referralCode}
          referralCodeError={referralCodeError}
          onReferralCodeChange={setReferralCode}
        />
      )}

      {step === "otp" && (
        <OtpStep
          form={otpForm}
          email={email}
          isSubmitting={isSubmitting}
          countdown={countdown}
          onSubmit={handleOtpSubmit}
          onBack={handleBack}
          onResend={handleResendOtp}
        />
      )}
    </div>
  );
}
